import { useTranslation } from 'react-i18next';
import type { SharedVenue } from '../../types';
import { Icon, MapPin, ExternalLink } from '../../components/ui/Icon';
import { CAT_META } from '../../utils/mapConstants';
import { SharedNote, EmptyNote } from './shared.ui';

export default function SharedPlaces({ venues }: { venues: SharedVenue[] }) {
  const { t } = useTranslation();

  if (venues.length === 0) return <EmptyNote>{t('shared.noPlaces')}</EmptyNote>;

  return (
    <div className="space-y-2">
      {venues.map(v => {
        const meta = CAT_META[v.category];
        return (
          <div key={v.id} className="card px-4 py-3 flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-slate-50 dark:bg-slate-800 flex items-center justify-center shrink-0">
              <Icon as={meta?.Icon ?? MapPin} size={16} className={meta?.color ?? 'text-slate-400'} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{v.name}</p>
              <div className="flex items-center gap-2 mt-0.5 flex-wrap text-2xs text-slate-400">
                {v.zone && <span>{v.zone}</span>}
                {v.address && <span className="truncate">{v.address}</span>}
                {v.priceInfo && <span>{v.priceInfo}</span>}
              </div>
              <SharedNote text={v.notes} />
            </div>
            {/* ADR-0001: this link was built from the place id we already store.
                A Place Details call just to learn the URL costs €0,017. */}
            {v.mapsUrl && (
              <a
                href={v.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('shared.openInMaps')}
                className="shrink-0 text-slate-300 hover:text-teal-500 transition-colors mt-1"
              >
                <Icon as={ExternalLink} size={14} />
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
}
